<div mat-dialog-title>
  <mode-dialog-header>
    <h1 heading>Share Report</h1>
  </mode-dialog-header>
  <nav mat-tab-nav-bar>
    <a
      mat-tab-link
      *ngFor="let tab of tabs"
      [disabled]="data.sendingEmail$ | async"
      [active]="activeTab === tab"
      (click)="activeTab = tab"
    >
      {{ tab }}
    </a>
  </nav>
</div>

<ng-container *ngIf="(reportRunStatus$ | async) === false">
  <mode-refresh-in-progress></mode-refresh-in-progress>
</ng-container>

<mode-dialog-loading-view *ngIf="(data.data$ | async) === null"></mode-dialog-loading-view>

<div *ngIf="data.sendingEmail$ | async; else tabsTemplate" mat-dialog-content class="sending-emails">
  <mode-dialog-loading-view
    title="Sending emails"
    [titleEllipsis]="true"
    subtitle="This may take a few moments"
  ></mode-dialog-loading-view>
</div>

<ng-template #tabsTemplate>
  <ng-container *ngIf="(reportRunStatus$ | async) && data.data$ | async as data" [ngSwitch]="activeTab">
    <div *ngSwitchCase="tab.Link" class="link">
      <mode-external-sharing
        [tooltipMessage]="data.externalSharingTooltip"
        [disabled]="data.externalSharingDisabled"
        [sharing]="data.reportShared"
        (sharingChange)="toggleExternalShare.emit($event)"
      ></mode-external-sharing>
      <mode-link-tab
        [internalLiveReportLink]="data.internalLiveReportLink"
        [internalStaticReportLink]="data.internalStaticReportLink"
        [externalLiveReportLink]="data.externalLiveReportLink"
        [externalStaticReportLink]="data.externalStaticReportLink"
        [reportShared]="data.reportShared"
      ></mode-link-tab>
    </div>

    <mode-slack-tab
      *ngSwitchCase="tab.Slack"
      [owner]="ownerInfo$ | async"
      [slackAppDetails]="data.slackAppDetails$ | async"
      [schedulingEnabled]="data.schedulingEnabled"
      (scheduleDelivery)="scheduleDelivery.emit()"
      (cancel)="cancel.emit()"
      (sendSlackMessage)="sendSlackMessage.emit($event)"
    ></mode-slack-tab>

    <mode-email-tab
      *ngSwitchCase="tab.Email"
      [formModel]="data.emailFormModel"
      [validEmailDomains]="data.validEmailDomains"
      [schedulingEnabled]="data.schedulingEnabled"
      [sharingTooltip]="data.externalSharingTooltip"
      [sharingDisabled]="data.externalSharingDisabled"
      [emailAttachmentsDisabled]="data.emailAttachmentsDisabled"
      [sharing]="data.reportShared"
      (sharingChange)="toggleExternalShare.emit($event)"
      (scheduleDelivery)="scheduleDelivery.emit()"
      (cancel)="cancel.emit()"
      (sendEmail)="sendEmail.emit($event)"
    ></mode-email-tab>
  </ng-container>
</ng-template>
